/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TajweedRouteImport } from './routes/tajweed'
import { Route as ReadPageRouteImport } from './routes/read.$page'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TajweedRoute = TajweedRouteImport.update({
  id: '/tajweed',
  path: '/tajweed',
  getParentRoute: () => rootRouteImport,
} as any)
const ReadPageRoute = ReadPageRouteImport.update({
  id: '/read/$page',
  path: '/read/$page',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/tajweed': typeof TajweedRoute
  '/read/$page': typeof ReadPageRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/tajweed': typeof TajweedRoute
  '/read/$page': typeof ReadPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/tajweed': typeof TajweedRoute
  '/read/$page': typeof ReadPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/tajweed' | '/read/$page'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/tajweed' | '/read/$page'
  id: '__root__' | '/' | '/tajweed' | '/read/$page'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TajweedRoute: typeof TajweedRoute
  ReadPageRoute: typeof ReadPageRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tajweed': {
      id: '/tajweed'
      path: '/tajweed'
      fullPath: '/tajweed'
      preLoaderRoute: typeof TajweedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/read/$page': {
      id: '/read/$page'
      path: '/read/$page'
      fullPath: '/read/$page'
      preLoaderRoute: typeof ReadPageRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TajweedRoute: TajweedRoute,
  ReadPageRoute: ReadPageRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
